import { useEffect } from "react";

// Print 2026-10-07: mapa inteiro cinza com "Sentimos muito, mas não temos
// imagens daqui." repetido em cada tile. Causa: no Satélite/Híbrido a
// imagem do Google só existe até um zoom que varia por lugar (em muita
// cidade do Brasil para em 19–20), mas o mapa vetorial deixa ir até 22 —
// rolar a roda do mouse, o "+" ou trocar de Ruas pra Satélite já de perto
// (ex.: vários rastreadores parados no mesmo estoque) passava desse limite.
// O MaxZoomService diz o zoom máximo real com imagem no centro atual; aqui
// ele vira o maxZoom do mapa e, se já estiver acima, a câmera desce pra ele.
// Em Ruas o limite é removido (roadmap tem tile até 22 em todo lugar).
const FALLBACK_SATELLITE_MAX_ZOOM = 19;

export function SatelliteZoomGuard({ Mod, mapTypeId }: { Mod: any; mapTypeId: string }) {
  const map = Mod.useMap() as google.maps.Map | null;
  const raster = mapTypeId === "satellite" || mapTypeId === "hybrid";

  useEffect(() => {
    if (!map || typeof google === "undefined") return;
    if (!raster) {
      map.setOptions({ maxZoom: null });
      return;
    }
    const service = new google.maps.MaxZoomService();
    let cancelled = false;
    let lastKey = "";
    const apply = (maxZoom: number) => {
      if (cancelled) return;
      map.setOptions({ maxZoom });
      const z = map.getZoom();
      const c = map.getCenter();
      // moveCamera (não setZoom) — sem zoom fracionário animado, mesmo
      // motivo do CameraController (deck.gl dessincroniza no raster).
      if (z != null && c && z > maxZoom) map.moveCamera({ center: c, zoom: maxZoom });
    };
    const check = () => {
      const c = map.getCenter();
      if (!c) return;
      // Um pedido por área (~1 km), não por cada "idle" de arrastar.
      const key = `${c.lat().toFixed(2)},${c.lng().toFixed(2)}`;
      if (key === lastKey) return;
      lastKey = key;
      service
        .getMaxZoomAtLatLng(c)
        .then((r) => apply(r.zoom))
        .catch(() => apply(FALLBACK_SATELLITE_MAX_ZOOM));
    };
    check();
    const idle = map.addListener("idle", check);
    return () => {
      cancelled = true;
      idle.remove();
    };
  }, [map, raster]);

  useEffect(() => {
    if (!map) return;
    return () => map.setOptions({ maxZoom: null });
  }, [map]);

  return null;
}
